var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card mb-4" }, [
    _c("div", { staticClass: "card-body reminder" }, [
      _c("h2", { staticClass: "card-title" }, [_vm._v("考試")]),
      _vm._v(" "),
      _c("p", { staticClass: "card-text" }),
      _vm._v(" "),
      _c("ol", { staticClass: "qa-list" }, [
        _c("li", [
          _c("h5", [_vm._v("我一定要參加學測嗎？")]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "視選擇的入學管道及校系而定，繁星推薦及申請入學除術科校系可能不參採外，餘均參採學測成績。 111 學年度起分發入學管道，大學校系除可以學測成績作為檢定外，亦可採計學測成績，考生應於學測報名前，確認有意報考的校系是否使用學測成績。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [_vm._v("我要如何選擇學測的考科？")]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "視您選擇的校系而定。繁星推薦使用學測成績作為檢定、分發比序項目，申請入學使用學測成績作為第一階段的檢定、倍率篩選及同級分超額篩選比序、第二階段的成績採計，分發入學則可將學測成績作為檢定或採計。請先參考各招生簡章之校系分則，查明您有意報名、就讀的校系使用哪些學測科目作為檢定、倍率篩選、採計及分發比序，就會知道您需要報考哪些學測考科。各入學管道會在當學年度學測報名前公吿校系參採之學測科目：\n\t\t\t\t"
            ),
            _vm._m(0),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v("如果學測有一科為零級分，可以參加繁星推薦及申請入學嗎？"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "自 107 學年度起，取消考生若有學測任一科為零級分不得參加分發比序/第一階段篩選之規定。只要考生有意報名的校系所使用到的學測科目級分加總後不為零級分就可以參加該管道招生，但是若校系訂為檢定之學測科目為零級分的話，將無法通過檢定，也就無法參加繁星推薦分發比序或申請入學第一階段之倍率篩選。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [_vm._v("學測的成績可以保留到明年使用嗎？")]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v("不可以。\n\t\t\t\t"),
            _c("br"),
            _vm._v(
              "學測成績只能在當學年度的入學管道中使用，並不能跨年度使用。「學科能力測驗成績保留五年」的意思是指大考中心為考生的學測成績保留五年，五年之中如果考生有需要，可向大考中心申請成績證明。\n\t\t\t\t"
            ),
            _c("br"),
            _vm._v(
              "教育部為鼓勵學生先累積社會歷練，多元探索志趣，推動「青年教育與就業儲蓄帳戶方案」，並配合提供更為暢通與彈性的就學管道，著重在學生參與職場、學習及國際體驗的資歷，使青年於計畫執行完成後，可繼續接軌升學。爰如您參加「青年教育與就業儲蓄帳戶方案」且計畫執行完成後，擬繼續接軌升學得於規定期限內，持「原畢業年度學測成績」，參加申請入學之青年儲蓄帳戶組招生。(有關「青年教育與就業儲蓄帳戶方案」相關事宜，得至"
            ),
            _c(
              "a",
              { attrs: { href: "https://www.edu.tw/1013/", target: "_blank" } },
              [_vm._v("教育部青年教育與就業儲蓄帳戶專區")]
            ),
            _vm._v(
              "網頁查詢或逕洽教育部青年發展署 (電話: (02)7736-5422)。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v(
              "「青年教育與就業儲蓄帳戶方案」(以下簡稱青儲方案)轉型為「青年生涯領航計畫」(以下簡稱青領計畫)後有什麼差異？學測的成績還可以保留使用嗎？"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "115年度起，本部青年發展署將青儲方案轉型為「青領計畫」；青儲方案青年及青領計畫青年之就學配套措施部分，摘要如下：\n\t\t\t\t"
            ),
            _vm._m(1),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v(
              "如果沒有參加學測，只參加分科測驗，是否可以參加「分發入學」招生管道？"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "可以，但只能選擇「分發入學」管道無需參採學測成績之校系。相關資訊可至"
            ),
            _c(
              "a",
              { attrs: { href: "https://www.uac.edu.tw", target: "_blank" } },
              [_vm._v("考分會網站")]
            ),
            _vm._v("選擇「校系分則」查詢。\n\t\t\t"),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [_vm._v("我一定要參加英聽或術科考試嗎？")]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "視您選擇的入學管道及校系而定。各入學管道會在當學年度英聽或術科考試報名前，公告檢定英聽的校系及參加術科考試的校系，考生可查閱當學年度繁星推薦、申請入學及分發入學3本招生簡章或直接上各入學管道網頁查詢，視自己欲報考的校系是否採計英聽或術科，來決定要不要參加英聽測驗或術科考試。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [_vm._v("我要如何選擇分科測驗的考科？")]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "如果您要報名的A學系採計分科測驗的物理、化學，您就一定要選考物理、化學。假設只選考化學，就會因「任一採計科目未報考」而無法分發A學系。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v(
              "學測、分科測驗或術科單項，若有1科為零（級）分，可以參加分發入學登記分發嗎？"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v("可以，但仍需要視您選擇的校系而定。\n\t\t\t\t"),
            _c("br"),
            _vm._v(
              "若您擇定的校系所檢定的學測科目為零級分，將無法通過檢定，無法參加分發。若分科測驗有1科目為零級分的話，可以參加分發，但考科組合未加權之級分和須達到最低登記標準，才可以選塡採計該組合的校系。另外，部分採計術科之校系，設有術科各單項0分不予分發的限制。詳見 116學年度大學分發入學招生簡章「貳、校系分則」中各校系之「選系說明」。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v(
              "學測成績通知單的成績表示是15級分制，什麼時候會知道60級分制的成績？"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "大考中心原則上於每年2月底公告學測成績並寄發成績通知單。\n\t\t\t\t成績通知單及網路查詢所列的各科最高為15級分，使用於繁星推薦檢定與比序、申請入學檢定、篩選與採計，以及分發入學檢定。\n\t\t\t\t"
            ),
            _c("br"),
            _vm._v(
              "學測使用於分發入學採計的成績各科最高為60級分，原則上會於每年4月中旬前開放網路查詢\n\t\t\t\t(以116學年度考試簡章公告日期為準)；另於每年7月底公告分科測驗成績時，考生之成績通知單及網路查詢之成績，除有分科測驗各科成績外，也會有學測使用於分發入學採計之成績\n\t\t\t\t（即考生報考學測之所有考科成績以60級分制表示）。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [_vm._v("我要如何準備大學入學相關考試呢？")]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v("歡迎各位考生至"),
            _c(
              "a",
              { attrs: { href: "https://www.ceec.edu.tw/", target: "_blank" } },
              [_vm._v("大考中心網站")]
            ),
            _vm._v(
              "查覽考試資訊、各項應試規則及注意事項，可線上瀏覽或下載：\n\t\t\t\t\t\t"
            ),
            _vm._m(2),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v("答題卷上印有本人應試號碼與姓名，依簡章規定考生仍須簽名？"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "111學年度起使用卷卡合一答題卷，並新增簽名欄位，若考生未於「確認後考生簽名」欄以正楷簽全名，會依違規處理辦法扣減成績。\n\t\t\t\t"
            ),
            _c("br"),
            _vm._v("英聽：於考試開始鈴聲響畢後，應依播音指示簽名。\n\t\t\t\t"),
            _c("br"),
            _vm._v(
              "學測與分科測驗：各節次考試開始鈴響起，考生即可於答題卷上之「確認後考生簽名」欄，以正楷簽全名。\n\t\t\t\t"
            ),
            _c("br"),
            _vm._v(
              "另各項考試，如因特殊情況使用備用答題卷，卷上雖無考生本人應試號碼與姓名，仍須於「確認後考生簽名」欄以正楷簽全名。\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v(
              "114學年度起分科測驗新增加的數學乙要考哪些內容？有哪些資訊可以參考？要如何準備？"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(" "),
            _vm._m(3),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h5", [
            _vm._v(
              "請問我不是108課綱的學生（如重考生、境外返國、高中肄業等），可以報名111學年度以後的英聽、學測、術科、分科測驗等考試嗎？"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qa-text" }, [
            _c("img", {
              attrs: { height: "25", src: _vm.content.qa, width: "25" },
            }),
            _vm._v(
              "可以，符合考試簡章所定報考資格者均得報考，與是否為修讀108課綱課程之學生無涉。\n\t\t\t"
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("p"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "list-paren-num" }, [
      _c("li", [
        _vm._v("繁星推薦：請至"),
        _c(
          "a",
          { attrs: { href: "https://www.cac.edu.tw", target: "_blank" } },
          [_vm._v("甄選會網站")]
        ),
        _vm._v("選擇「繁星推薦」進入「訊息公吿」或「校系分則查詢」。"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("申請入學：請至"),
        _c(
          "a",
          { attrs: { href: "https://www.cac.edu.tw", target: "_blank" } },
          [_vm._v("甄選會網站")]
        ),
        _vm._v("選擇「申請入學」進入「訊息公吿」或「校系分則查詢」。"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("分發入學：請至"),
        _c(
          "a",
          { attrs: { href: "https://www.uac.edu.tw", target: "_blank" } },
          [_vm._v("考分會網站")]
        ),
        _vm._v("選擇「最新消息」或「校系分則」。"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "list-paren-num" }, [
      _c("li", [
        _vm._v("青儲方案：\n\t\t\t\t\t\t"),
        _c("ol", [
          _c("li", [_vm._v("四技二專特殊選才入學聯合招生、彈性選系。")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("四技二專甄選入學、大學申請入學實施至117學年度截止。"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("青領計畫：四技二專特殊選才入學聯合招生、彈性選系。")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "118學年度起無四技二專甄選入學、大學申請入學兩招生管道，因此學測成績無法保留。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v("\n\t\t\t\t\t\t\t\t考試資訊：\n\t\t\t\t\t\t\t\t"),
        _c("ol", { staticClass: "list-paren-num" }, [
          _c("li", [
            _vm._v(
              "大考中心於官網設有高中英語聽力測驗、學科能力測驗、分科測驗（110前指考）等考試專區，且於各考試專區下設有該項考試各類之相關訊息，其中「考試訊息」刊登各次考試的即時資訊，包括依試務日程之提醒事項。"
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "各項考試專區皆有試題相關內容，如：考試說明，內含測驗目標與試題舉例；參考試卷，提供試卷可能架構。學測與分科測驗專區另有歷年試題，包括一般試題與答案，以及近年該次考試有製作之特殊試題。適用108課綱之試題，可參考111至115學年度之學測及分科測驗各科試題、答題卷、選擇（填）題答案與非選擇題評分原則。英聽測驗則可參考每年度公布的一卷試題示例，其中111至115年所公布者為依據108課綱所命試題。"
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "另大考中心網站「宣導與研習」專區，置放了各科命題方向等相關影音資料、簡報，包括部分試題分析的影片，試題停、看、聽系列等。"
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "各項應試規則與應考注意事項：除簡章與各項考試專區之考試訊息外，大考中心網站「考生試務宣導」專區，置放了影音媒介與各類說明，以及應考注意事項。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "114學年度起分科測驗新增加的數學乙考科測驗範圍，包含10年級必修數學、11年級必修數學A類及數學B類均關聯的學習內容，以及12年級加深加廣選修數學乙類。如欲詳加了解該考科之測驗目標、測驗內容與試題舉例，可至大考中心網站之分科測驗（110前指考）專區，點選「考試說明」，參閱「分科測驗數學考科考試說明-114學年度起適用（112年5月2日更新）」。"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "若考生想了解數學乙考科整份試卷之樣貌，可至大考中心網站分科測驗（110前指考）專區，點選「參考試卷」，參閱「114學年度起適用之分科測驗數學乙考科參考試卷」。該次公布之參考試卷計兩卷，每卷皆包含整卷試題、答題卷、參考答案、評分原則，以及試題解析等，提供不同之題卷樣貌與題型配置。亦可至「歷屆試題與答題卷」參閱-115學年度分科測驗數學乙考科之正式試題與答題卷。"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "分科測驗數學乙考科題型包含單選、多選、選塡與混合題型，其中有關混合題型形式，另可以參閱大考中心網站學科能力測驗– 歷屆試題及答題卷（111至115學年度）數學A、數學B試卷，或是分科測驗–歷屆試題及答題卷（111至115學年度）數學甲、數學乙（114學年度起）試卷，將有助考生了解混合題型的命題方式與答題卷設計。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }